'use client';

import type { QuestionReconstructedType } from '~/model/QuestionType';
import type { TranslationTypeValue } from '~/model/TranslationType';
import { useTranslations } from 'next-intl';
import Slider from 'rc-slider';
import { isRangeDividableByStep } from '~/components/Interaction/Form/Question/Types/Scale';
import {
  calculateMarks,
  calculateNumberOfMarks,
  calculateSliderMarks,
} from '~/components/Interaction/utils';
import { roundToNDecimal } from '~/utils/utils';

export const ScaleResult = ({
  question,
  resultData,
  questionLabel,
}: ScaleResultPropsType) => {
  const t = useTranslations('SURVEY.RESULTS');

  const { limit_min, limit_max, step, type } = question;
  const scaleSliderCanBeRendered
    = isRangeDividableByStep(limit_min, limit_max, step) || step === 0;

  const numberOfMarks = calculateNumberOfMarks(
    scaleSliderCanBeRendered,
    step,
    limit_min,
    limit_max,
  );

  const marks = calculateMarks(
    scaleSliderCanBeRendered,
    numberOfMarks,
    step,
    limit_min,
  );

  const sliderMarks = calculateSliderMarks(
    scaleSliderCanBeRendered,
    marks,
    limit_min,
    limit_max,
  );
  const roundAverage = roundToNDecimal(resultData?.average);

  return (
    <div data-testid="scale">
      {!!resultData?.average && (
        <div className="result__banner">
          {t.rich('AVERAGE', {
            roundAverage,
          })}
        </div>
      )}
      {
        // hide labels if step is zero
        step !== 0 && (
          <div className="vas__labels">
            <span>{questionLabel?.label_min}</span>
            <span>{questionLabel?.label_middle}</span>
            <span>{questionLabel?.label_max}</span>
          </div>
        )
      }
      {scaleSliderCanBeRendered && !!resultData?.average && (
        <Slider
          className={`${type} RESULT`}
          value={resultData.average}
          min={limit_min}
          max={limit_max}
          marks={sliderMarks}
          step={0.1}
        />
      )}
    </div>
  );
};

export interface ScaleResultPropsType {
  question: QuestionReconstructedType;
  resultData: Data;
  questionLabel: TranslationTypeValue;
}

interface Data {
  average: number;
}
